import { render, staticRenderFns } from "./BemInput.vue?vue&type=template&id=0202ae9e&"
import script from "./BemInput.vue?vue&type=script&lang=js&"
export * from "./BemInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports